import React, { useState, useEffect } from 'react'
import { 
    Input, 
    Modal, 
    Form, 
    Col, 
    Row, 
    Select, 
    Switch, 
    Spin, 
    message, 
    Divider, 
    Typography, 
    Card,
    Badge,
    Radio,
    Alert,
    Collapse,
    Space
} from 'antd'
import { getCustomerOneNew, getCustomerListNew, platformUserList } from '@/service/customerService'
import { getOrganCurrentUser, organPage } from '@/service/orgService'
import { getTeamList } from '@/service/teamService'
import { orderEditCustomerUser } from '@/service/ordersService'
import { getPcodeDict } from '@/utils/dataStorage'
import debounce from 'lodash/debounce'
import { 
    ExclamationCircleOutlined, 
    UserOutlined, 
    CarOutlined, 
    PhoneOutlined,
    MailOutlined,
    HomeOutlined,
    TeamOutlined,
    BankOutlined,
    InfoCircleOutlined,
    SwapOutlined,
    EditOutlined
} from '@ant-design/icons'

const { Option } = Select
const { Title, Text, Paragraph } = Typography
const { Panel } = Collapse

// 客户类型常量
const CUSTOMER_TYPES = {
    SPECIAL: '017008',
    NORMAL: '017001',
}

// 样式配置
const styles = {
    // 布局样式
    layout: {
        display: 'flex',
        height: '100%',
        minHeight: '500px',
    },
    leftColumn: {
        width: '35%',
        padding: '20px',
        borderRight: '1px solid #f0f0f0',
        background: '#fafafa',
    },
    rightColumn: {
        width: '65%',
        padding: '20px',
        overflowY: 'auto',
        background: '#fff',
    },
    
    // 卡片样式
    card: {
        marginBottom: '20px',
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
    },
    cardTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#1f1f1f',
    },
    
    // 信息显示样式
    infoRow: {
        display: 'flex',
        alignItems: 'center',
    },
    infoLabel: {
        color: '#555',
        marginRight: '12px',
        fontSize: '14px',
        fontWeight: 'bold',
        minWidth: '100px',
        textAlign: 'right',
    },
    infoValue: {
        color: '#333',
        fontSize: '14px',
        fontWeight: '500',
        flex: 1,
    },
    
    // 表单样式优化
    formContainer: {
        padding: '8px 0',
    },
    panelHeader: {
        fontSize: '15px',
        fontWeight: '500',
        color: '#1890ff',
    },
    formSection: {
        marginBottom: '16px',
        padding: '16px',
        background: '#f9f9f9',
        borderRadius: '4px',
    },
    sectionTitle: {
        fontSize: '16px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        color: '#333',
    },
    
    // 模式选择样式
    modeSelector: {
        margin: '20px 0',
    },
    modeButton: {
        width: '50%',
        textAlign: 'center',
        height: '40px',
        lineHeight: '38px',
    },
    modeDescription: {
        color: '#666',
        fontSize: '14px',
        margin: '12px 0 20px',
        lineHeight: '1.5',
    },
    
    // 客户选择区域
    customerSelector: {
        marginBottom: '20px',
        padding: '16px',
        background: '#f6ffed',
        border: '1px solid #b7eb8f',
        borderRadius: '4px',
    },
    
    // 订单信息区域
    orderInfo: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    orderInfoItem: {
        display: 'flex',
        alignItems: 'center',
    },
    orderInfoIcon: {
        color: '#1890ff',
        marginRight: '8px',
        fontSize: '16px',
    },
    orderInfoLabel: {
        color: '#666',
        marginRight: '8px',
        fontSize: '14px',
    },
    orderInfoValue: {
        color: '#333',
        fontSize: '14px',
        fontWeight: '500',
    },
    
    // 表单样式
    formContainer: {
        padding: '0 8px',
    },
    formSection: {
        marginBottom: '24px',
    },
    formSectionTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '16px',
        borderLeft: '3px solid #1890ff',
        paddingLeft: '10px',
    },
    formRow: {
        marginBottom: '16px',
    },
    
    // 其他样式
    divider: {
        margin: '16px 0',
    },
}

const OrderCustomerEdit = (props) => {
    const { visible, onCancel, orderDetailsInfo, orderVehicleInfo, handleSuccess } = props
    const [form] = Form.useForm()
    
    // 状态管理
    const [activeMode, setActiveMode] = useState('switch') // 'switch' 或 'edit'
    const [originCustomerInfo, setOriginCustomerInfo] = useState({})
    const [customerName, setCustomerName] = useState('')
    
    // 数据列表状态
    const [customerInfo, setCustomerInfo] = useState({
        data: [],
        fetching: false,
    })
    const [organList, setOrganList] = useState({ 
        data: [], 
        fetching: false 
    })
    const [teamData, setTeamData] = useState({
        data: [],
        fetching: false,
    })
    const [businessManager, setBusinessManager] = useState({
        data: [],
        fetching: false,
    })

    // 初始化原客户信息
    useEffect(() => {
        resetFormItem()
        setOriginCustomerInfo({
            customerName: orderDetailsInfo.customerName,
            customerCode: orderDetailsInfo.customerCode,
            customerCorporation: orderDetailsInfo.customerCorporation,
            customerCorporationPhone: orderDetailsInfo.customerCorporationPhone,
            customerType: orderDetailsInfo.customerType,
            customerStatus: orderDetailsInfo.customerStatus,
        })
    }, [orderDetailsInfo])

    // 设置默认业务经理
    const setDefultbusinessManager = async () => {
        const data = await getOrganCurrentUser()
        const { defBusinessManager, defBusinessManagerName } = data.retData
        if (defBusinessManager) {
            return { text: defBusinessManagerName, value: defBusinessManager }
        } else {
            return null
        }
    }

    //回显表单
    const resetFormItem = async (handleChangeCustomerId = '') => {
        let defaultbusiness = await setDefultbusinessManager()
        const res = await getCustomerOneNew(handleChangeCustomerId ? handleChangeCustomerId : orderDetailsInfo.customerId)
        if (!res || !res.retData) {
            message.error('获取客户信息失败')
            return
        }

        let retData = res.retData
        let { businessManager } = retData
        if (!businessManager) {
            setBusinessManager({
                data: defaultbusiness ? [defaultbusiness] : [],
                fetching: false,
            })
            businessManager = defaultbusiness ? defaultbusiness.value : null
        } else {
            setBusinessManager({
                data: [{ text: retData.businessManagerName, value: retData.businessManager }],
                fetching: false,
            })
        }
        form.setFieldsValue({
            ...retData,
            businessManager,
            customerId: retData.id,
            customerStatus: retData.customerStatus == 0 ? true : false,
            customerType: retData.customerType === CUSTOMER_TYPES.SPECIAL ? CUSTOMER_TYPES.NORMAL : retData.customerType,
        })
        setTeamData({
            data: [{ text: retData.teamName, value: retData.teamId }],
            fetching: false,
        }) //团队列表回显
        setCustomerInfo({
            data: [{ text: retData.customerName, value: retData.id }],
            fetching: false,
        })
        //客户列表回显
        setCustomerName(retData.customerName)
        setOrganList({
            data: [
                {
                    text: retData.organName,
                    value: retData.organId,
                },
            ],
            fetching: false,
        })
        // }
    }
    //团队派单信息查询
    const fetchTeam = (value) => {
        setTeamData({
            data: [],
            fetching: true,
        })
        let data = {
            teamName: value ? value : null,
            searchItem: {},
            pageSize: 50,
            pageNum: 1,
        }
        getTeamList(data).then((res) => {
            // if (res && res.retCode === 200) {
            let results = res.retData.list
            const dataMap = results.map((team) => ({
                text: team.teamName,
                value: team.id,
            }))
            setTeamData({
                data: dataMap,
                fetching: false,
            })
            // }
        })
    }
    //防抖
    const fetchTeams = debounce(fetchTeam, 500) // 减少延迟时间

    const handleChangeTeam = (value, option) => {
        form.setFieldsValue({
            teamName: option.children,
        })
    }
    //客户列表查询
    const customerQuery = (value) => {
        setCustomerInfo({
            ...customerInfo,
            fetching: true,
        })
        getCustomerListNew({
            pageSize: 20,
            currentPage: 1,
            searchItem: {
                queryTemporaryCustomer: 1,
                customerName: value,
            },
        }).then((res) => {
            // if (res && res.retCode === 200) {
            let results = res.retData.list
            const data = results.reduce((arr, item) => {
                if (item.customerStatus === 0) {
                    arr.push({
                        text: item.customerName,
                        value: item.id,
                    })
                }
                return arr
            }, [])
            setCustomerInfo({
                data: data,
                fetching: false,
            })
            // }
        })
    }

    // 切换操作模式
    const handleModeChange = (e) => {
        const mode = e.target.value
        setActiveMode(mode)
        
        if (mode === 'edit') {
            // 切换到编辑模式时恢复原始客户ID
            form.setFieldsValue({
                customerId: orderDetailsInfo.customerId
            })
            
            // 清除客户选择列表
            setCustomerInfo({ data: [], fetching: false })
            
            // 恢复原始客户信息
            resetFormItem(orderDetailsInfo.customerId)
        }
    }
    
    // 选择新客户
    const handleChangeName = (value) => {
        value && resetFormItem(value)
    }
    // 保存客户信息
    const saveEditCustomer = async () => {
        try {
            const value = await form.validateFields()
            const data = {
                ...value,
                orderId: orderDetailsInfo.id,
                customerStatus: value.customerStatus ? 0 : 1,
                customerVehicleId: orderVehicleInfo.key,
                customerUserId: orderDetailsInfo.customerUserId,
            }

            const res = await orderEditCustomerUser(data)
            if (!res) {
                throw new Error('保存失败')
            }

            handleSuccess({
                customerName: data.customerName,
                customerId: data.customerId,
                customerType: data.customerType,
            })
            
            onCancel(false)
            message.success('该工单的客户修改完成')
            setActiveMode('edit')
        } catch (error) {
            message.error('保存失败: ' + (error.message || '请检查表单填写'))
        }
    }
    //防抖
    const customerQuerys = debounce(customerQuery, 1000)
    //查询机构
    const organQuery = (value) => {
        setOrganList({
            data: [],
            fetching: true,
        })
        let data = {
            searchItem: { organName: value, orderFlag: 0 },
            pageNum: 1,
            pageSize: 10,
            orders: [{ column: 'createTime', rule: 'DESC' }],
        }
        organPage(data).then((res) => {
            // if (res && res.retCode === 200) {
            let results = res.retData.list
            if (results && results.length > 0) {
                const data = results.map((item) => ({
                    text: item.organName,
                    value: item.id,
                }))
                setOrganList({
                    data: data,
                    fetching: false,
                })
            } else {
                message.warning('没有查询到机构')
            }
            // }
        })
        // .catch((err) => {
        //     if (err) {
        //         message.warning("没有查询到机构")
        //     }
        // })
    }
    //防抖
    const organQuerys = debounce(organQuery, 600)
    
    const formItemLayout = {
        labelCol: { span: 9 },
        wrapperCol: { span: 15 },
    }

    const handleChangeOrgan = (value, option) => {
        if (option) {
            form.setFieldsValue({
                organId: value,
                organName: option.children,
            })
        }
    }

    const businessManagerQuery = (value, key) => {
        setBusinessManager({
            ...businessManager,
            fetching: true,
        })

        platformUserList({
            searchItem: {
                nickname: value,
            },
            pageNum: 1,
            pageSize: 15,
        }).then((res) => {
            let results = res.retData.list
            if (results && results.length > 0) {
                const data = results.reduce((arr, item) => {
                    arr.push({
                        text: item.nickname,
                        value: item.id,
                    })
                    return arr
                }, [])
                setBusinessManager({
                    data: data,
                    fetching: false,
                })
            } else {
                console.log('没有查询到')
            }
        })
    }
    //防抖
    const businessManagerQuerys = debounce(businessManagerQuery, 1000)

    return (
        <Modal
            visible={visible}
            title={activeMode === 'switch' ? '切换客户' : '编辑客户信息'}
            centered={true}
            onOk={() => saveEditCustomer()}
            onCancel={() => {
                onCancel(false)
            }}
            width={1200}
            bodyStyle={{ padding: 0, maxHeight: '80vh', overflowY: 'auto' }}
            destroyOnClose={true}
        >
            {/* 两栏布局 */}
            <div style={styles.layout}>
                {/* 左侧栏 - 原客户信息和切换客户功能 */}
                <div style={styles.leftColumn}>
                    {/* 原客户信息卡片 */}
                    <Card 
                        title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <InfoCircleOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                <span>原客户信息</span>
                            </div>
                        }
                        style={styles.card}
                        size="small"
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <div style={styles.infoRow}>
                                <span style={styles.infoLabel}>客户名称:</span>
                                <span style={styles.infoValue}>{originCustomerInfo.customerName || '-'}</span>
                            </div>
                            <div style={styles.infoRow}>
                                <span style={styles.infoLabel}>客户编码:</span>
                                <span style={styles.infoValue}>{originCustomerInfo.customerCode || '-'}</span>
                            </div>
                            <div style={styles.infoRow}>
                                <span style={styles.infoLabel}>联系人:</span>
                                <span style={styles.infoValue}>{originCustomerInfo.customerCorporation || '-'}</span>
                            </div>
                            <div style={styles.infoRow}>
                                <span style={styles.infoLabel}>联系电话:</span>
                                <span style={styles.infoValue}>{originCustomerInfo.customerCorporationPhone || '-'}</span>
                            </div>
                            <div style={styles.infoRow}>
                                <span style={styles.infoLabel}>客户类型:</span>
                                <span style={styles.infoValue}>
                                    {getPcodeDict('017').children.find(item => item.dictCode === originCustomerInfo.customerType)?.title || '-'}
                                </span>
                            </div>
                            <div style={styles.infoRow}>
                                <span style={styles.infoLabel}>客户状态:</span>
                                <span style={styles.infoValue}>
                                    <Badge 
                                        status={originCustomerInfo.customerStatus === 0 ? 'success' : 'error'} 
                                        text={originCustomerInfo.customerStatus === 0 ? '正常' : '禁用'} 
                                    />
                                </span>
                            </div>
                        </div>
                    </Card>

                    {/* 操作模式选择 */}
                    <div style={styles.modeSelector}>
                        <Radio.Group 
                            value={activeMode} 
                            onChange={handleModeChange}
                            buttonStyle="solid"
                            style={{ width: '100%' }}
                        >
                            <Radio.Button value="switch" style={styles.modeButton}>
                                <SwapOutlined style={{ marginRight: '8px' }} />
                                切换客户
                            </Radio.Button>
                            <Radio.Button value="edit" style={styles.modeButton}>
                                <EditOutlined style={{ marginRight: '8px' }} />
                                编辑信息
                            </Radio.Button>
                        </Radio.Group>
                    </div>
                    
                    {/* 模式说明 */}
                    <div style={styles.modeDescription}>
                        {activeMode === 'switch' 
                            ? '在切换客户模式下，您可以选择新客户，订单将关联到新选择的客户。选择客户后可以查看客户详细信息。' 
                            : '在编辑信息模式下，您只能编辑原始客户的详细信息，如联系人、电话、地址等。如果您已切换客户，切换到编辑模式将恢复原始客户信息。'}
                    </div>
                    
                    {/* 客户选择区域 - 仅在切换模式显示 */}
                    {activeMode === 'switch' && (
                        <div style={styles.customerSelector}>
                            <Title level={5}>选择新客户</Title>
                            <Form.Item
                                name="customerId"
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择客户名称',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="请输入客户名称搜索并选择"
                                    notFoundContent={customerInfo.fetching ? <Spin size="small" /> : null}
                                    filterOption={false}
                                    onChange={handleChangeName}
                                    onFocus={() => customerQuery()}
                                    onSearch={customerQuerys}
                                    style={{ width: '100%' }}
                                    size="large"
                                >
                                    {customerInfo.data.map((item) => (
                                        <Option value={item.value} key={item.value}>
                                            {item.text}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            
                            <Alert
                                type="warning"
                                message="切换客户提醒"
                                description="选择新客户后，当前订单的用户信息和车辆信息将会迁移到新客户名下。此操作不可逆，请谨慎操作。"
                                showIcon
                            />
                        </div>
                    )}
                    
                    {/* 订单相关信息 */}
                    <div style={styles.orderInfo}>
                        <Title level={5}>订单相关信息</Title>
                        <div style={styles.orderInfoItem}>
                            <UserOutlined style={styles.orderInfoIcon} />
                            <span style={styles.orderInfoLabel}>用户名:</span>
                            <span style={styles.orderInfoValue}>{orderDetailsInfo.customerUserName || '-'}</span>
                        </div>
                        <div style={styles.orderInfoItem}>
                            <CarOutlined style={styles.orderInfoIcon} />
                            <span style={styles.orderInfoLabel}>车辆牌照:</span>
                            <span style={styles.orderInfoValue}>{orderVehicleInfo && orderVehicleInfo.children || '-'}</span>
                        </div>
                        <div style={styles.orderInfoItem}>
                            <PhoneOutlined style={styles.orderInfoIcon} />
                            <span style={styles.orderInfoLabel}>电话:</span>
                            <span style={styles.orderInfoValue}>{orderDetailsInfo.repairContactPhone || '-'}</span>
                        </div>
                    </div>
                </div>
                
                {/* 右侧栏 - 客户详细信息编辑表单 */}
                <div style={styles.rightColumn}>
                    <Card 
                        title={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {activeMode === 'switch' ? 
                                    <SwapOutlined style={{ marginRight: '8px', color: '#52c41a' }} /> : 
                                    <EditOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                }
                                <span>{activeMode === 'switch' ? '新客户信息预览' : '客户信息编辑'}</span>
                            </div>
                        }
                        style={{ marginBottom: '20px' }}
                    >
                    <Form form={form} {...formItemLayout} style={styles.formContainer}>
                        <Form.Item name="customerId" hidden={true}>
                            <Input />
                        </Form.Item>
                        
                        {/* 基本信息部分 */}
                        <div style={{ marginBottom: '24px' }}>
                            <div style={{ ...styles.sectionTitle, marginBottom: '16px' }}>
                                <TeamOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                <span>基本信息</span>
                            </div>
                            <div style={{ padding: '0 8px' }}>
                                <Row gutter={[32, 20]}>
                                    <Col span={16}>
                                        <Form.Item
                                            label="客户名称"
                                            name="customerName"
                                            labelCol={{ span: 4 }}
                                            wrapperCol={{ span: 20 }}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '请输入客户名称',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="请输入客户名称" disabled={activeMode === 'switch'} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="客户编码" name="customerCode">
                                            <Input disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            label="客户类型"
                                            name="customerType"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '请选择客户类型',
                                                },
                                            ]}
                                        >
                                            <Select placeholder="请选择客户类型" disabled={activeMode === 'switch'}>
                                                {getPcodeDict('017').children.map((item) => (
                                                    <Option value={item.dictCode} key={item.id}>
                                                        {item.title}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="客户状态" name="customerStatus" valuePropName="checked">
                                            <Switch checkedChildren="开启" unCheckedChildren="关闭" disabled={activeMode === 'switch'} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="所属机构" name="organId">
                                            <Select
                                                showSearch
                                                placeholder="请选择所属机构"
                                                notFoundContent={organList.fetching ? <Spin size="small" /> : null}
                                                filterOption={false}
                                                onFocus={() => organQuery('')}
                                                onSearch={organQuerys}
                                                onSelect={handleChangeOrgan}
                                                style={{ width: '100%' }}
                                                disabled={activeMode === 'switch'}
                                            >
                                                {organList.data.map((item) => (
                                                    <Option value={item.value} key={item.value}>
                                                        {item.text}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="所属团队" name="teamId">
                                            <Select
                                                showSearch
                                                allowClear
                                                placeholder="请选择创业团队"
                                                notFoundContent={teamData.fetching ? <Spin size="small" /> : null}
                                                filterOption={false}
                                                onChange={handleChangeTeam}
                                                onFocus={() => fetchTeam()}
                                                onSearch={fetchTeams}
                                                style={{ width: '100%' }}
                                                disabled={activeMode === 'switch'}
                                            >
                                                {teamData.data.map((item) => (
                                                    <Option value={item.value} key={item.value}>
                                                        {item.text}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="业务经理" name="businessManager">
                                            <Select
                                                showSearch
                                                placeholder="请选择业务经理"
                                                notFoundContent={businessManager.fetching ? <Spin size="small" /> : null}
                                                filterOption={false}
                                                onFocus={() => businessManagerQuerys('')}
                                                onSearch={businessManagerQuerys}
                                                style={{ width: '100%' }}
                                                disabled={activeMode === 'switch'}
                                            >
                                                {businessManager.data.map((item) => (
                                                    <Option value={item.value} key={item.value}>
                                                        {item.text}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        
                        {/* 联系方式部分 */}
                        <div style={{ marginBottom: '24px' }}>
                            <div style={{ ...styles.sectionTitle, marginBottom: '16px' }}>
                                <PhoneOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                <span>联系方式</span>
                            </div>
                            <div style={{ padding: '0 8px' }}>
                                <Row gutter={[32, 20]}>
                                    <Col span={8}>
                                        <Form.Item label="联系人" name="customerCorporation">
                                            <Input placeholder="请输入联系人" disabled={activeMode === 'switch'} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="联系电话" name="customerCorporationPhone">
                                            <Input placeholder="请输入联系电话" disabled={activeMode === 'switch'} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="办公电话" name="customerPhone">
                                            <Input placeholder="请输入办公电话" disabled={activeMode === 'switch'} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="电子邮箱" name="customerEmail">
                                            <Input placeholder="请输入电子邮箱" disabled={activeMode === 'switch'} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="传真" name="customerFax">
                                            <Input placeholder="请输入传真" disabled={activeMode === 'switch'} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="邮编" name="customerZipcode">
                                            <Input placeholder="请输入邮编" disabled={activeMode === 'switch'} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        
                        {/* 其他信息部分 */}
                        <div style={{ marginBottom: '24px' }}>
                            <div style={{ ...styles.sectionTitle, marginBottom: '16px' }}>
                                <HomeOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                                <span>其他信息</span>
                            </div>
                            <div style={{ padding: '0 8px' }}>
                                <Row gutter={[32, 20]}>
                                    <Col span={24}>
                                        <Form.Item label="地址" name="customerAddress" labelCol={{ span: 2 }} wrapperCol={{ span: 22 }}>
                                            <Input placeholder="请输入联系地址" disabled={activeMode === 'switch'} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="备注" name="customerDesc" labelCol={{ span: 2 }} wrapperCol={{ span: 22 }}>
                                            <Input.TextArea 
                                                placeholder="请输入备注" 
                                                disabled={activeMode === 'switch'} 
                                                autoSize={{ minRows: 2, maxRows: 4 }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Form>
                    </Card>
                </div>
            </div>
        </Modal>
    )
}

export default OrderCustomerEdit
